module.exports = __webpack_public_path__ + "img/handraw_avis .fb702687.svg";